/*eslint-disable no-unused-vars */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import moment from 'moment';

class Greetings {
  contructor() {
    this.humanizedGreeting = '';
  }

  getGreetings = (currentTime = new Date()) => {
    const currentHour = currentTime.getHours();

    const splitAfternoon = 12; //24hr time to split the afternoon
    const splitEvening = 17; //24hr time to split the evening

    if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
      //Between 12 PM and 5PM
      return 'Good Afternoon';
    } else if (currentHour >= splitEvening) {
      //Between 5PM and Midnight
      return 'Good Evening';
    }
    //Between dawn and noon
    return 'Good Morning';
  };

  formatDate = (dt) => {
    return moment(dt).format('MMM Do YY');
  };
}

export default new Greetings();
